import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ValentinesDayReservations from '../../components/ValentinesDayReservations/ValentinesDayReservations';
import Loader from '../../components/Loader/Loader';
import heroImage from './imgs/ResyHero_1920x450-4.png';
import menuImage from './imgs/Valentines Day Menu.jpg';

import * as elementsActions from '../../redux/actions/elements';

class ValentinesReservations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  renderHowDoesThisWorkSection = () => {
    return (
      <section className="px-4 xl:px-0 max-w-screen-desktop mx-auto py-6">
        <div className="flex flex-col md:items-center justify-center gap-3 h-[88px]">
          <h2 className="font-congenialBlack text-4xl leading-9 tracking-[-1px] text-dark">
            How Does This Work?
          </h2>
        </div>
        <div className="w-full flex flex-col md:flex-row items-start justify-center gap-4">
          <div className="flex flex-col items-center gap-4 flex-1">
            <p
              className="h-[43px] w-[43px] bg-dark text-white rounded-full flex items-center justify-center
              text-xl font-congenialBlack"
            >
              1
            </p>
            <div className="w-full flex flex-col items-center justify-center gap-2">
              <h3 className="font-montserratBold text-2xl leading-6 tracking-[-0.3px] text-button text-center">
                Pick a bakery
              </h3>
              <p className="text-lg font-montserratMedium leading-[22px] tracking-[-0.1px] text-darkElevationPrimary text-center">
                Find a participating bakery near you to join the fun.
              </p>
            </div>
          </div>
          <div className="flex flex-col items-center gap-4 flex-1">
            <p
              className="h-[43px] w-[43px] bg-dark text-white rounded-full flex items-center justify-center
              text-xl font-congenialBlack"
            >
              2
            </p>
            <div className="w-full flex flex-col items-center justify-center gap-2">
              <h3 className="font-montserratBold text-2xl leading-6 tracking-[-0.3px] text-button text-center">
                Pick a perfect time
              </h3>
              <p className="text-lg font-montserratMedium leading-[22px] tracking-[-0.1px] text-darkElevationPrimary text-center">
                Select a time slot that fits your needs, whether it’s date night, Galentine’s, or just because.
              </p>
            </div>
          </div>
          <div className="flex flex-col items-center gap-4 flex-1">
            <p
              className="h-[43px] w-[43px] bg-dark text-white rounded-full flex items-center justify-center
              text-xl font-congenialBlack"
            >
              3
            </p>
            <div className="w-full flex flex-col items-center justify-center gap-2">
              <h3 className="font-montserratBold text-2xl leading-6 tracking-[-0.3px] text-button text-center">
                Save your Sweet Spot
              </h3>
              <p className="text-lg font-montserratMedium leading-[22px] tracking-[-0.1px] text-darkElevationPrimary text-center">
                Confirm your weekend plans and get ready for a seriously sweet Valentine’s Day moment.
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  };

  renderParticipatingBakeriesSection = () => {
    const {
      useRecaptcha,
      setVerificationToken,
      setVerificationAction,
      setVerificationProvider,
      userOrderMethod,
      addressComponents,
    } = this.props;
    return (
      <section className="px-4 xl:px-0 max-w-screen-desktop mx-auto py-6">
        <div className="flex flex-col justify-center gap-3 h-[88px]">
          <h2 className="font-congenialBlack text-4xl leading-9 tracking-[-1px] text-dark">
            Find Participating Bakeries
          </h2>
        </div>
        <ValentinesDayReservations
          useRecaptcha={useRecaptcha}
          setVerificationToken={setVerificationToken}
          setVerificationAction={setVerificationAction}
          setVerificationProvider={setVerificationProvider}
          userOrderMethod={userOrderMethod}
          location={addressComponents}
        />
      </section>
    );
  };

  render() {
    const { loading } = this.state;

    if (loading) {
      return (
        <div className="w-full flex justify-center bg-dark min-h-screen">
          <div className="w-full">
            <Loader id="loader" />
          </div>
        </div>
      );
    }

    return (
      <div className="w-full min-h-screen dark:bg-dark bg-[#f6f3f7]">
        <div
          className="w-full mx-auto mb-4 bg-cover bg-center"
          style={{
            backgroundImage: `url(${heroImage})`,
            height: '384px'
          }}
        />
        <section className="px-4 xl:px-0 max-w-screen-desktop mx-auto py-6">
          <h1 className="font-congenialBlack text-4xl leading-9 tracking-[-1px] text-dark mb-4">
            Your Valentine’s Day Plans just got better.
            <br />
            Reserve your table at Insomnia for the first-time ever.
          </h1>
          <p className="text-lg font-montserratMedium leading-[22px] tracking-[-0.1px] text-darkElevationPrimary mb-4">
            Insomnia has quickly become the go-to late-night date spot for couples everywhere,
            so this Valentine’s Day, we’re opening reservations at select U.S. & Canada
            bakeries for you and your sweetheart to celebrate with us.
          </p>
          <h2 className="font-montserratBold text-xl leading-6 tracking-[-0.3px] text-button mb-2">
            With your reservation you&apos;ll receive:
          </h2>
          <p className="text-lg font-montserratMedium leading-[22px] tracking-[-0.1px] text-darkElevationPrimary">1. Guaranteed seating for two – you and …whoever!</p>
          <p className="text-lg font-montserratMedium leading-[22px] tracking-[-0.1px] text-darkElevationPrimary">2. An optional pre-fixed menu to enjoy (or order from our regular menu as usual!) Note: prix fixe menu is at select bakeries.</p>
          <p className="text-lg font-montserratMedium leading-[22px] tracking-[-0.1px] text-darkElevationPrimary">3. Serious bragging rights...because who else gets to do this at their local bakery!?</p>
        </section>
        <section className="px-4 xl:px-0 max-w-screen-desktop mx-auto py-6">
          <img src={menuImage} alt="Valentine's Day Menu" className="w-full" />
        </section>
        {this.renderHowDoesThisWorkSection()}
        {this.renderParticipatingBakeriesSection()}
      </div>
    );
  }
}

ValentinesReservations.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  useRecaptcha: PropTypes.bool,
  setVerificationToken: PropTypes.func,
  setVerificationAction: PropTypes.func,
  setVerificationProvider: PropTypes.func,
  userOrderMethod: PropTypes.string,
  addressComponents: PropTypes.shape({}),
};

ValentinesReservations.defaultProps = {
  useRecaptcha: false,
  setVerificationToken: () => {},
  setVerificationAction: () => {},
  setVerificationProvider: () => {},
  userOrderMethod: '',
  addressComponents: null,
};

export const mapStateToProps = (state) => ({
  addressComponents: state.address.addressComponents,
  useRecaptcha: state.elements.useRecaptcha,
  userOrderMethod: state.user.userOrderMethod,
});

export const mapDispatchToProps = (dispatch) => ({
  setVerificationToken: (token) => dispatch(elementsActions.setVerificationToken(token)),
  setVerificationAction: (action) => dispatch(elementsActions.setVerificationAction(action)),
  setVerificationProvider: (provider) => dispatch(elementsActions.setVerificationProvider(provider)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ValentinesReservations);